import { forwardRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useController } from 'react-hook-form';

interface RecaptchaInputProps {
  onChange: (value: boolean) => void;
  onBlur: () => void;
  value: boolean;
  disabled?: boolean;
  name: string;
}

export const RecaptchaInput = forwardRef<HTMLInputElement, RecaptchaInputProps>((props, _ref) => {
  const onChange = (token: string | null) => {
    props.onChange(!!token);
  };

  return (
    <ReCAPTCHA
      size="normal"
      sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
      onChange={onChange}
    />
  );
});

interface ControlledRecaptchaInputProps {
  name: string;
}

export const ControlledRecaptchaInput = ({ name }: ControlledRecaptchaInputProps) => {
  const controller = useController({ name });
  return <RecaptchaInput {...controller.field} name={name} />;
};
